<template>
  <div class="manage-advise">
    <el-row type="flex" align="middle" justify="space-between" class="mb-l">
      <el-row type="flex" align="middle" class="page-title">
        <i class="el-icon-menu mr-s" />
        <h3>Danh sách Advise</h3>
      </el-row>
    </el-row>
    <el-form :model="form" inline ref="form">
      <el-form-item>
        <el-input
          v-model="form.email"
          @input="handleSearchAdvise"
          clearable
          placeholder="Email"
          class="search mb-xl"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form.description"
          @input="handleSearchAdvise"
          clearable
          placeholder="Description"
          class="search mb-xl"
        />
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="end">
      <el-button
        size="medium"
        type="primary"
        class="mb-m"
        @click="handleRefreshData"
      >
        <i class="el-icon-refresh"></i>
      </el-button>
    </el-row>
    <el-table :data="advises" border v-loading="callingAPI">
      <el-table-column label="#" type="index" align="center" width="50px" />
      <el-table-column label="Email" width="250px">
        <template slot-scope="scope"> {{ scope.row.email }} </template>
      </el-table-column>
      <el-table-column label="Phone" width="250px">
        <template slot-scope="scope"> {{ scope.row.mobile }} </template>
      </el-table-column>
      <el-table-column label="Nội dung">
        <template slot-scope="scope"> {{ scope.row.description }} </template>
      </el-table-column>
      <el-table-column label="Support" align="center" width="130px">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleUpdateAdvise(scope.row)"
            :type="scope.row.support == 2 ? 'success' : 'warning'"
          >
            {{ scope.row.support == 2 ? "Đã support" : "Chờ support" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="Xoá" align="center" width="70px">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="small"
            @click="handeRemoveAdvise(scope.row)"
            icon="el-icon-delete"
            circle
          />
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" class="mt-m">
      <el-pagination
        background
        layout="prev, pager, next"
        :disabled="callingAPI"
        @current-change="handleChangePage"
        :currentPage="page"
        :pageSize="pageSize"
        :total="total"
      />
    </el-row>
  </div>
</template>

<script>
import { fetchAdvise, deleteAdvise, updateAdvise } from "@/services/advise";
export default {
  name: "ManageNeedAdvise",
  data() {
    return {
      callingAPI: false,
      debounce: null,

      advises: [],

      page: 1,
      pageSize: 10,
      total: 0,

      form: {
        email: "",
        description: "",
      },
    };
  },
  async beforeMount() {
    await this.loadData();
  },
  methods: {
    async handleRefreshData() {
      this.$refs.form.resetFields();
      await this.loadData();
    },

    async loadData(page = null) {
      try {
        this.callingAPI = true;
        const params = {
          email: this.form.email,
          description: this.form.description,
          phone: this.form.phone,
          page: page ? page : 1,
          per_page: this.pageSize,
        };
        const response = await fetchAdvise(params);
        this.advises = response.data.data;
        this.total = response.data.total;
        this.callingAPI = false;
      } catch (error) {
        this.callingAPI = false;
      }
    },

    async handleSearchAdvise() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.loadData();
      }, 500);
    },

    async handleChangePage(page) {
      this.page = page;
      await this.loadData(page);
    },

    async handleUpdateAdvise(row) {
      this.$confirm(
        `Đánh dấu ${row.support == 2 ? "chưa support" : "đã support"} ?`,
        "Warning",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Huỷ",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const data = {
              support: row.support == 2 ? 1 : 2,
            };
            const response = await updateAdvise(row.id, data);
            if (response.status === 0) {
              this.callingAPI = false;
              this.$notify.error({
                title: "Thất bại",
                message: response.message,
                duration: 2000,
              });
              return;
            }
            await this.loadData(this.page);
            this.$notify.success({
              title: "Thành công",
              message: `Cập nhật thành công.`,
              duration: 2000,
            });
          } catch (error) {
            this.$notify.error({
              title: "Thất bại",
              message: "Cập nhật thất bại.",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },

    async handeRemoveAdvise(row) {
      this.$confirm(`Chắc chắn muốn xoá ?`, "Warning", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      })
        .then(async () => {
          try {
            this.callingAPI = true;
            const response = await deleteAdvise(row.id);
            if (response.status === 0) {
              this.callingAPI = false;
              this.$notify.error({
                title: "Thất bại",
                message: response.message,
                duration: 2000,
              });
              return;
            }
            await this.loadData(this.page);
            this.$notify.success({
              title: "Thành công",
              message: `Xoá thành công.`,
              duration: 2000,
            });
          } catch (error) {
            this.callingAPI = false;
            this.$notify.error({
              title: "Thất bại",
              message: "Xoá thất bại.",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
</style>
